<template lang="pug">
.overlay
  #overlayMax.comAll(v-dragDiv v-show="!showMin && !actionData.isMini")
    .title.moveDragDiv
      span {{actionData.cnName}}
      el-button(size='mini' plain @click='openTree' v-if="showOther") 添加叠图文件
      i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
      i.el-icon-close.closebtn(title='关闭' @click='closeCom')
    .contentCom(v-loading='loading' element-loading-text='对比数据请求中...')
      el-table(ref='multipleTable',
        :data='tableData',
        tooltip-effect='dark',
        style='width: 100%',
        border
        @select='changeRow')
        el-table-column(type='selection' width='55' :selectable='selectable')
        el-table-column(prop='stackedFileName' label='图纸名称' show-overflow-tooltip='')
        el-table-column(prop='version' label='图纸颜色' width='85' align='center')
          template(slot-scope='{ row }')
            el-color-picker(v-model='row.color' size='mini' :predefine="predefineColors" @change='changeColor(row)')
        el-table-column(label='操作' align='center' width='85')
          template(slot-scope='scope')
            el-button.colorBtn(size='mini' type='text' @click='deleteMap(scope.row)') 删除
      .footer
        el-button(size='mini' type='primary' @click='openMin') 最小化叠图
        el-button(size='mini' @click='closeOverlay') 关闭所有叠图
  #overlayMin(v-show='showMin')
    .title
      span {{actionData.cnName}}
      el-button(size='mini' type='primary' @click='openMax') 最大化
      i.el-icon-close.closebtn(title='关闭' @click='closeCom')
    .tableMin
      el-table(ref='tinyTable',
        border
        :data='minMapList',
        @select-all='changeAll',
        @select='changeMinRow',
        height='150',
        :loading='loadingTable')
        el-table-column(type='selection' width='55')
        el-table-column(prop='stackedFileName' show-overflow-tooltip='' label='图纸名称')
        el-table-column(prop='' label='图纸颜色' width='80' align='center')
          template(slot-scope='{ row }')
            el-tag(:color='row.color' style='border-radius: 100%; height: 20px; width: 20px')
        el-table-column(align='center' width='220' label='操作')
          template(slot-scope='scope')
            el-button(type='mini' @click="mapStatus(scope.row,'move')") 移动
            el-button(type='mini' @click="mapStatus(scope.row,'scale')") 缩放
            el-button(type='mini' @click="mapStatus(scope.row,'reset')") 复位
  el-dialog(title='选择文件' :modal='false' append-to-body width='400px' :before-close='handleClose' :visible.sync='contrastFlag')
    el-tree(v-if='contrastFlag',
      v-loading='treeLoading',
      style='height:300px;overflow-y:auto',
      :props='defaultProps',
      :default-expanded-keys='unfoldIdArr',
      check-on-click-node,
      :load='loadNode',
      accordion,
      :check-strictly='true',
      highlight-current,
      node-key='folderId',
      lazy,show-checkbox,
      @check='handleCheckChange',
      @node-click='clickNodeTree')
      template(#default='{ node,data }')
        span.treeStyle
          img(:src='folder_icon(data)' alt='图标')
          span {{ node.label }}
    span.dialog-footer(slot='footer')
      el-button(size='mini' type='primary' @click='sureFile') 确 定
      el-button(size='mini' @click='handleClose') 取 消

</template>

<script>
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false,
      showMin: false,
      tableData: [],
      contrastFlag: false,
      treeLoading: false,
      defaultProps: { children: 'children', label: 'folderName', isLeaf: 'leaf' }, // 树形结构
      unfoldIdArr: [],
      otherDwgId: [],
      minMapList: [],
      loadingTable: false,
      predefineColors: [
        'rgb(255, 0, 0)',
        'rgb(255, 255, 0)',
        'rgb(0, 255, 0)',
        'rgb(0, 255, 255)',
        'rgb(0, 0, 255)',
        'rgb(255, 0, 255)',
        'rgb(255, 255, 255)',
        'rgb(128, 128, 128)',
        'rgb(192, 192, 192)'
      ],
      selectList: []
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    overlayList() {
      return mongeApp.map.overlayList;
    },
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    showOther() {
      return this.dwgdata.prjId !== "MyDoc" || this.dwgdata.prjId !== "EnterpriseDoc";
    },
    argnmentParams() {
      const argument = {
        folderId: '0',
        prjId: this.dwgdata.prjId,
        isRead: 1,
        isNew: '',
        priviAll: '1',
        versionId: '',
        versionName: "",
        isPersonal: '',
        noRightClickMenu: true,
        flag: false
      };
      return argument;
    }
  },
  mounted() {
    this.queryList();
  },
  methods: {
    // 叠图列表
    async queryList() {
      try {
        this.loading = true;
        const res = await mongeService.overlaySearch(this.dwgdata.fileId);
        this.tableData = res.data?.map(e => { return { ...e, color: "#ffffff" }; });
        await this.$nextTick();
        const list = this.overlayList.map(row => {
          const obj = this.tableData.find(ele => ele.stackedFileId === row.stackedFileId);
          this.$refs.multipleTable.toggleRowSelection(obj);
          return obj;
        });
        mongeMutations.setOverlayList(list);
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 删除叠图
    async deleteMap(row) {
      if (this.overlayList.some(e => e.stackedFileId === row.stackedFileId)) {
        const list = this.overlayList.filter(e => e.stackedFileId !== row.stackedFileId);
        mongeMutations.setOverlayList(list);
        await this.mapListRequest(row.stackedFileId, row.version, row.color, "unload");
      }
      const params = {
        fileId: this.dwgdata.fileId,
        stackedFileId: row.stackedFileId
      };
      await mongeService.overlayDel(params);
      this.$message.success("删除成功");
      await this.queryList();
    },
    // 选中/取消选中
    changeRow(val, row) {
      this.selectList = val;
      mongeMutations.setOverlayList(val);
      if (val.some(e => e.stackedFileId === row.stackedFileId)) {
        this.loading = true;
        this.mapListRequest(row.stackedFileId, row.version, row.color, "load");
      } else {
        this.mapListRequest(row.stackedFileId, row.version, row.color, "unload");
      }
    },
    async changeMinRow(val, row) {
      this.selectList = val;
      mongeMutations.setOverlayList(val);
      if (val.some(e => e.stackedFileId === row.stackedFileId)) {
        this.mapListRequest(row.stackedFileId, row.version, row.color, "load");
      } else {
        this.mapListRequest(row.stackedFileId, row.version, row.color, "unload");
      }
    },
    changeColor(row) {
      if (this.selectList.some(e => e.stackedFileId === row.stackedFileId)) {
        this.mapListRequest(row.stackedFileId, row.version, row.color, "unload");
        this.mapListRequest(row.stackedFileId, row.version, row.color, "load");
      }
    },
    miniCom() {
      this.$emit('closeCom', 'overlay', true);
    },
    closeCom() {
      this.$emit('closeCom', 'overlay', false);
    },
    closeOverlay() {
      this.overlayList.forEach(async row => {
        await this.mapListRequest(row.stackedFileId, row.version, row.color, "unload");
        const obj = this.tableData.find(ele => ele.stackedFileId === row.stackedFileId);
        this.$refs.multipleTable.toggleRowSelection(obj);
      });
      mongeMutations.setOverlayList();
    },
    openTree() {
      this.contrastFlag = true;
    },
    handleClose() {
      this.contrastFlag = false;
    },
    handleCheckChange(checkedNodes, checkedKeys, halfCheckedNodes, halfCheckedKeys) {
      this.otherDwgId = checkedKeys.checkedNodes || [];
    },
    async clickNodeTree(data, node) {
      this.publicOpenFolder(data, node);
    },
    publicOpenFolder(data, node) {
      this.unfoldIdArr = [];
      this.loadNode(node);
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const result = await mongeService.queryTree(this.argnmentParams);
        const filterData = [];
        result.data.forEach(item => {
          item.disabled = true;
          if (item.folderId !== 'recycle') { // 去掉回收站
            filterData.push(item);
          }
        });
        typeof resolve === 'function' && resolve(filterData);
        this.treeLoading = false;
      } else {
        this.getChildren(node, resolve);
      }
    },
    async getChildren(node, resolve) {
      const folderId = node.data.folderId;
      const params = {
        ...this.argnmentParams,
        folderId: folderId
      };
      const res = await mongeService.queryTree(params);
      const data = res.data.filter(item => item.isFolder === 1 || item.fileType === 8);
      data.forEach(item => {
        if (item.isFolder === 1) {
          item.children = [];
          item.leaf = false;
          item.disabled = true;
        } else if (item.isFolder === 1 && item.fileType === 8) {
          item.leaf = true;
        } else if (this.tableData.some(e => e.stackedFileId === item.folderId)) {
          item.disabled = true;
        } else if (item.isFolder === 0 && item.fileType === 8 && !(item.status === '2' || item.status === '6')) {
          item.disabled = true;
        }
      });
      typeof resolve === 'function' && resolve(data);
    },
    async sureFile() {
      if (this.otherDwgId.length === 0) {
        this.$message.warning("请选择一张图纸");
        return;
      }
      const stackedFileList = this.otherDwgId.map(ele => {
        return { stackedFileId: ele.folderId, stackedFileName: ele.folderName };
      });
      const params = {
        fileId: this.dwgdata.fileId,
        stackedFileList
      };
      try {
        await mongeService.overlayAdd(params);
        this.contrastFlag = false;
        this.queryList();
      } catch (error) {
        this.contrastFlag = false;
      }
    },
    async openMin() {
      this.showMin = !this.showMin;
      this.minMapList = this.overlayList;
      await this.$nextTick();
      this.overlayList.forEach(row => {
        this.$refs.tinyTable.toggleRowSelection(row, true);
      });
    },
    async openMax() {
      this.showMin = !this.showMin;
      await this.$nextTick();
      this.$refs.multipleTable.clearSelection();
      this.overlayList.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row, true);
      });
    },
    // 最小化 全选
    async changeAll(val) {
      await mongeMutations.setOverlayList(val);
      if (val.length === 0) {
        this.minMapList.forEach(async row => {
          await this.mapListRequest(row.stackedFileId, row.version, row.color, "unload");
        });
      } else {
        this.minMapList.forEach(async row => {
          await this.mapListRequest(row.stackedFileId, row.version, row.color, "load");
        });
      }
    },
    // 移动//缩放//重置
    mapStatus(row, type) {
      if (!this.overlayList.some(e => e.stackedFileId === row.stackedFileId)) {
        this.$message.info("请先叠加该图纸");
        return;
      }
      this.mapListRequest(row.stackedFileId, row.version, row.color, type);
    },
    async mapListRequest(fileId, fileVersion, color, type) {
      const colorData = parseInt(color.substr(1), 16);
      let picsurl;
      if (this.mlibEnabled) {
        const res = await mongeService.queryModelLightFilesFromMLib(fileId, fileVersion);
        const utlList = await mongeApiMlib.dealMongeFiles(res.data || {});
        picsurl = utlList.find(e => e.fileName === JSON.parse(this.spaceOfDwgData));
      } else {
        const res = await mongeService.queryDwgSpace(fileId, fileVersion);
        const utlList = mongeApiMlib.assembleUrl(res.data);
        picsurl = utlList.find(e => e.picName === JSON.parse(this.spaceOfDwgData))?.picsurl;
      }
      switch (type) {
        case "load":
          await mongeApiMlib.loadDrawing(picsurl, colorData);
          break;
        case "unload":
          await mongeApiMlib.unloadDrawing(picsurl);
          break;
        case "move":
          await mongeApiMlib.mapMove(picsurl);
          break;
        case "scale":
          await mongeApiMlib.mapScale(picsurl);
          break;
        case "reset":
          await mongeApiMlib.mapReset(picsurl);
          break;
      }
      this.loading = false;
    },
    folder_icon(data) {
      let imgIcon;
      if (data.fileType === 8) {
        imgIcon = require("../images/dwg.png");
      } else {
        imgIcon = require("../images/tableZiDoc.png");
      }
      return imgIcon;
    },
    selectable(row, index) {
      if (row.fileId === row.stackedFileId) {
        return false;
      }
      return true;
    }
  }

};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#overlayMax{
  position:absolute;
  bottom: 95px;
  left :calc(50% - 290px);
  width :580px;
  height: 450px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .contentCom{
    flex: 1;
    padding: 10px 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .el-table{
      flex: 1;
      overflow-y: auto;
      /deep/ .el-table__header-wrapper .el-checkbox {
        display: none;
      }
      .colorBtn {
        color: #2590EB;
      }
    }
    .footer{
      height: 30px;
      width: 100%;
      padding: 0 20px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
#overlayMin{
  width: 460px;
  background: #fff;
  height: 200px;
  position: absolute;
  bottom: 95px;
  right: 10px;
  overflow: hidden;
  .title{
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    background: #c7d0e1;
    border-bottom: 1px solid #DCE1ED;
    >span{
      margin-right: auto;
    }
    .el-button{
      margin-right: 10px;
    }
    i{
      cursor: pointer;
    }
  }
  .tableMin{
    width: 100%;
    height: calc(100% - 40px);
    // padding: 0 10px;
    overflow-y: auto;
  }
}
/deep/ .el-tree-node__content{
  display: flex;
  flex-direction: row;
  align-items: center;
  .treeStyle{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight:400;
    >img{
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
    >span{
      font-size: 12px;
    }
  }
}
</style>
<style lang="scss" >
	.el-color-dropdown__link-btn{
		display: none;
	}
</style>
